import { actionTypes } from '../constants';
import { getHousesModel } from './selectors';
import { houseHasCrossRelationsConfirm } from './housesModelConfirmation';
import {
  ExcludedRoomHasRelationHandler,
  ExcludedRoomListHasRelationHandler,
  ExcludeHouseHandler,
} from './handlers/excludeRoom';

export const searchChanged = (value) => ({
  type: actionTypes.houseSearchChanged,
  payload: value,
});

export const selectedSearchChanged = (value) => ({
  type: actionTypes.houseSelectedSearchChanged,
  payload: value,
});

export const filterChanged = (value) => ({
  type: actionTypes.houseFilterChanged,
  payload: value,
});

export const relationAdded = (room, relatedRooms) => ({
  type: actionTypes.relationAdded,
  payload: { room, relatedRooms },
});

export const relationDeleted = (room) => ({
  type: actionTypes.relationDeleted,
  payload: room,
});

export const roomFromRelationDeleted = (room) => ({
  type: actionTypes.roomFromRelationDeleted,
  payload: room,
});

export const roomsCountSet = (dataMap) => ({
  type: actionTypes.roomsCountSet,
  payload: dataMap,
});

export const allHousesClicked = (houses, selected) => (dispatch) => {
  const action = selected
    ? { type: actionTypes.allHousesSelected, payload: houses }
    : { type: actionTypes.allHousesDeselected };

  dispatch(action);
};

export const houseClicked = (house, selected) => (dispatch, getState) => {
  if (selected) {
    dispatch({ type: actionTypes.houseSelected, payload: house });
    return;
  }

  const { id } = house;
  const housesModel = getHousesModel(getState());
  const parentRooms = housesModel.houseCrossParentsToRender(id);
  const childRooms = housesModel.houseCrossChildrenToRender(id);

  if (!parentRooms && !childRooms) {
    dispatch({ type: actionTypes.houseDeselected, payload: id });
    return;
  }

  houseHasCrossRelationsConfirm({
    onOk: () => {
      dispatch({ type: actionTypes.houseDeselected, payload: id });
    },
    currentHouseId: id,
    parentRooms,
    childRooms,
  });
};

export const roomExcludeClicked =
  (roomData, checked) => (dispatch, getState) => {
    if (checked) {
      dispatch({ type: actionTypes.roomIncluded, payload: roomData });
      return;
    }

    const excludeHouseHandler = new ExcludeHouseHandler();
    excludeHouseHandler.setNext(new ExcludedRoomHasRelationHandler());

    const handled = excludeHouseHandler.handle({
      roomData,
      housesModel: getHousesModel(getState()),
      dispatch,
    });

    if (!handled) {
      dispatch({ type: actionTypes.roomExcluded, payload: roomData });
    }
  };

export const allRoomsExcludeClicked =
  (rooms, checked) => (dispatch, getState) => {
    if (checked) {
      dispatch({ type: actionTypes.roomListIncluded, payload: rooms });
      return;
    }

    const excludeHouseHandler = new ExcludeHouseHandler();
    excludeHouseHandler.setNext(new ExcludedRoomListHasRelationHandler());

    const handled = excludeHouseHandler.handle({
      roomData: rooms,
      housesModel: getHousesModel(getState()),
      dispatch,
    });

    if (!handled) {
      dispatch({ type: actionTypes.roomListExcluded, payload: rooms });
    }
  };
